module.exports = __webpack_public_path__ + "media/images/athletes/1772-7cddac881c62a1785304a9e56f0dca11.png";